









































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { Toast, Popup, Picker, Button, Icon, Dialog } from 'vant';
import { isWeiXin } from '@/common/ts/common';
import {
  getQuestionsList,
  submitAnswer,
  getBaseInfo,
  getDepartments,
  login,
} from './api';
import WxOpenAppTip from '@/plugins/WxOpenAppTip';
import '@vant/touch-emulator';

Vue.use(Toast)
  .use(Popup)
  .use(Picker)
  .use(Button)
  .use(Icon)
  .use(Dialog)
  .use(WxOpenAppTip);

@Component
export default class Home extends Vue {
  name = '';
  selectedDepartment = '请选择部门';
  selectedDepartmentVal = -1;
  departments: string[] = [];
  showPicker = false;
  showQuestionsJumper = false;
  introBoxVisible = true;
  questions: any[] = [];
  activeQuestionIndex = 0;
  timestamp: any = '';
  showModal = false;
  score: number = 0;
  userAnswer: any = {};
  showNoChanceNotice = false;
  restTime = 120;
  countDownTimer: any = null;

  get flatQuestions() {
    if (!this.questions.length) {
      return [];
    }
    const r = this.questions.reduce((pre: any, cur: any) => {
      return [...pre, ...cur];
    });
    return r;
  }

  get resultText() {
    let result = '';
    if (this.score >= 90) {
      result = '恭喜你测试通过!';
    } else {
      result = '很遗憾，你尚未通过测试!';
    }
    return result;
  }

  @Watch('restTime')
  onRestTimeChange(newval: number) {
    if (newval === 0) {
      clearInterval(this.countDownTimer);
      Dialog.alert({
        message: '已到交卷时间，考试结束',
      }).then(() => {
        this.sendPaper();
      });
    }
  }

  created() {
    (document.querySelector('meta[name=viewport]') as HTMLMetaElement).content =
      'width=device-width,initial-scale=1.0, user-scalable=1';
    // console.log(document.querySelector('meta[name=viewport]'));
    Toast.setDefaultOptions({
      forbidClick: true,
      duration: 800,
    });
    this.onGetDepartments();
    this.onGetQuestionsList();
    // this.$addPv(401);
    // this.$appShareInfo({
    //   title: '新型冠状病毒防护考试试卷（全国卷）',
    //   image:
    //     'https://image2.cqcb.com/d/file/topics/activity/2020-02-08/2apMWZXTbB.jpg',
    //   url: location.href,
    //   subtitle: '全民必答！新型冠状病毒防护考试全国卷来了',
    //   classId: -1,
    //   id: -1,
    //   type: 3,
    // });
    // if (isWeiXin()) {
    //   // 微信分享
    //   this.$wxShareInfo({
    //     title: '新型冠状病毒防护考试试卷（全国卷）',
    //     subtitle: '全民必答！新型冠状病毒防护考试全国卷来了',
    //     image:
    //       'https://image2.cqcb.com/d/file/topics/activity/2020-02-08/2apMWZXTbB.jpg',
    //     link: location.href,
    //   });
    // }
  }

  async onGetDepartments() {
    const ret = await getDepartments();
    this.departments = ret.data.map((item: any) => item.title);
  }

  checkUserInfo() {
    if (!this.name) {
      Toast('请输入姓名');
      return false;
    } else if (this.selectedDepartmentVal === -1) {
      Toast('请选择部门');
      return false;
    } else {
      return true;
    }
  }

  togglePicker() {
    this.showPicker = !this.showPicker;
  }

  onConfirm(value: string, index: number) {
    this.togglePicker();
    this.selectedDepartment = value;
    this.selectedDepartmentVal = index;
  }
  onCancel() {
    this.togglePicker();
  }

  async onGetQuestionsList() {
    const ret = await getQuestionsList();
    const d2Arr = Object.values(ret.data);
    const mappedData = d2Arr.map((groupItemArr: any, groupIndex: number) => {
      return groupItemArr.map((item: any, index: any) => {
        return {
          options: [
            {
              mark: 'A',
              value: item.answer_a,
            },
            {
              mark: 'B',
              value: item.answer_b,
            },
            {
              mark: 'C',
              value: item.answer_c,
            },
            {
              mark: 'D',
              value: item.answer_d,
            },
          ],
          userMarkedAnswer: '',
          parentIndex: groupIndex,
          ...item,
        };
      });
    });
    this.questions = mappedData;
    this.timestamp = (new Date().getTime() / 1000).toFixed(0);
  }

  jumpToIntro() {
    if (!window.udid && !isWeiXin()) {
      this.$openAppTip();
      return;
    }
    this.introBoxVisible = true;
  }
  async onJumpToAnswer() {
    // 验证用户有无输入姓名和部门
    if (!this.checkUserInfo()) {
      return;
    }
    const ret: any = await login({
      name: this.name,
      department: this.selectedDepartment,
    });
    Toast(ret.msg);
    // 处理返回状态码
    // code: 201=答题超过3次 100失败
    if (ret.code === 201) {
      // 跳转至答题结算页面
      this.toggleNotice();
      this.score = ret.data;
    } else if (ret.code === 200) {
      // 登录成功
      this.introBoxVisible = false;
      this.countDownTimer = setInterval(() => {
        if (this.restTime > 0) {
          this.restTime--;
        }
      }, 60 * 1000);
    } else {
      return console.log('答题结束或登录失败');
    }
  }
  // 选择答案
  async onSelect(questionItem: any, answer: string) {
    const currentQuestion = this.questions[questionItem.parentIndex][
      Number(questionItem.number) - 1
    ];
    currentQuestion.userMarkedAnswer = answer;
    this.userAnswer[currentQuestion.id] = answer;
  }
  // 发送答卷
  async sendPaper() {
    if (this.countDownTimer) {
      clearInterval(this.countDownTimer);
    }
    // 发送答卷
    const ret = await submitAnswer({
      name: this.name,
      department: this.selectedDepartment,
      answer: JSON.stringify(this.userAnswer),
    });
    console.log('ret submit answer:', ret);
    this.score = ret.data;
    this.activeQuestionIndex = this.flatQuestions.length;
  }

  async next(item: any, index: number) {
    if (this.activeQuestionIndex === this.flatQuestions.length - 1) {
      console.log('答题结束, 进入结算页面');
      Dialog.confirm({
        title: '确定提交本次测试？',
      })
        .then(async () => {
          this.sendPaper();
        })
        .catch(() => {
          console.log('cancel');
        });
    } else {
      this.activeQuestionIndex++;
    }
  }
  // 题库快速跳转
  onQuickJump(questionItem: any) {
    this.activeQuestionIndex = this.flatQuestions.findIndex(
      (item: any) => item.id === questionItem.id,
    );
    this.toggleQuestionsJumper();
  }
  // 重置
  reset() {
    if (this.countDownTimer) {
      clearInterval(this.countDownTimer);
    }
    this.activeQuestionIndex = 0;
    this.introBoxVisible = true;
    this.restTime = 120;
    this.userAnswer = {};
    this.score = 0;
    this.onGetQuestionsList();
  }
  toggleNotice() {
    this.showNoChanceNotice = !this.showNoChanceNotice;
  }
  toggleModal() {
    this.showModal = !this.showModal;
  }
  toggleQuestionsJumper() {
    this.showQuestionsJumper = !this.showQuestionsJumper;
  }
  onBlur() {
    const u = navigator.userAgent;
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isiOS) {
      window.scrollTo(0, 0);
    }
  }
}
